export const blockType = (position) => {
  var dInside = [21, 22, 31, 32, 41, 42, 51, 52];
  var dInsideOpp = [29, 30, 39, 40, 49, 50, 59, 60];
  var dTop = [61, 62, 71, 72];
  var dTopOpp = [69, 70, 79, 80];
  var dBottom = [1, 2, 11, 12];
  var dBottomOpp = [9, 10, 19, 20];
  var centerField = [23, 24, 25, 33, 34, 35, 43, 44, 45, 53, 54, 55];
  var centerFieldOpp = [26, 27, 28, 36, 37, 38, 46, 47, 48, 56, 57, 58];
  var centerFieldTop = [63, 64, 65, 73, 74, 75];
  var centerFieldTopOpp = [66, 67, 68, 76, 77, 78];
  var centerFieldBottom = [3, 4, 5, 13, 14, 15];
  var centerFieldBottomOpp = [6, 7, 8, 16, 17, 18];

  const coordinateMapping = {
    D_INSIDE: { rows: 11, columns: 9 },
    D_TOP_BOTTOM: { rows: 9, columns: 9 },
    CENTER_FIELD: { rows: 11, columns: 14 },
    CENTER_FIELD_TOP_BOTTOM: { rows: 9, columns: 14 },
  };

  if (dInside.includes(position) || dInsideOpp.includes(position)) {
    return coordinateMapping.D_INSIDE;
  } else if (
    dTop.includes(position) ||
    dBottom.includes(position) ||
    dTopOpp.includes(position) ||
    dBottomOpp.includes(position)
  ) {
    return coordinateMapping.D_TOP_BOTTOM;
  } else if (
    centerField.includes(position) ||
    centerFieldOpp.includes(position)
  ) {
    return coordinateMapping.CENTER_FIELD;
  } else if (
    centerFieldTop.includes(position) ||
    centerFieldBottom.includes(position) ||
    centerFieldTopOpp.includes(position) ||
    centerFieldBottomOpp.includes(position)
  ) {
    return coordinateMapping.CENTER_FIELD_TOP_BOTTOM;
  } else {
    return "INVALID";
  }
};
